import React, { useContext } from "react";

import { observer } from "mobx-react";

import { Button } from "@components/buttons";
import { Bet } from "@models";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetCancelStore } from "@state/stores/my-bets/BetCancelStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

import { BetDetailsAutoSellButton, BetDetailsCashOutButton } from "../common";
import { BetDetailsAutoSellConfirmation } from "./autosell-components";
import {
	BetDetailsBetCancel,
	BetDetailsBetCancelMessage,
} from "./bet-cancel-components";
import {
	BetDetailsCashOutFooter,
	CashOutSubmittingComponent,
} from "./cashout-components";
import { BetDetailsReuse } from "./reuse-components";

export const BetDetailsModalFooter = observer(
	function BetDetailsModalFooter(props: { currentBet: Bet }) {
		const store = useContext(BetDetailsModalStoreContext);

		let betCancelStore: BetCancelStore;
		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			betCancelStore = store.myBetsStore.betCancelStore;
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			betCancelStore = store.betCancelStore;
			cashoutStore = store.cashoutStore;
		}

		if (!props.currentBet) {
			return null;
		}

		if (store.isShareActive) {
			return null;
		}

		if (betCancelStore.betCancelMessage !== null) {
			return <BetDetailsBetCancelMessage />;
		}

		if (store.isBetCancelOpen && betCancelStore.betCancelMessage === null) {
			return <BetDetailsBetCancel />;
		}

		if (cashoutStore.isCashoutFormSubmitting) {
			return <CashOutSubmittingComponent />;
		}

		if (!cashoutStore.isCountdownVisible && store.isCashoutOpen) {
			return (
				<MyBetsBetContext.Provider value={props.currentBet}>
					<div className="popup__footer popup__footer--bordered">
						<BetDetailsCashOutFooter store={store} />
					</div>
				</MyBetsBetContext.Provider>
			);
		}

		if (store.isAutoSellOpen) {
			return <BetDetailsAutoSellConfirmation />;
		}

		if (store.isReuseOpen) {
			return (
				<div className="popup__footer popup__footer--bordered">
					<BetDetailsReuse />
				</div>
			);
		}

		return (
			<MyBetsBetContext.Provider value={props.currentBet}>
				<div className="popup__footer popup__footer--bordered">
					<div className="popup__footer__row">
						{store instanceof BetDetailsModalStore && (
							<Button
								type="button"
								switchIcon
								isMostPlayed
								className="btn--square btn--square--med btn--primary--inverted"
								iconClassName={
									"u-icon--tny u-icon--caret-left" +
									(store.isFirst
										? " u-color--sent--muted"
										: " u-color--text--secondary")
								}
								iconOnly
								onClick={store.moveLeft}
								disabled={store.isFirst}
							/>
						)}

						{!store.currentBet?.isCashoutUnavailable ? (
							<div className="btn btn--med btn--split btn--block bet__btn__split">
								<BetDetailsCashOutButton store={store} />
								<BetDetailsAutoSellButton />
							</div>
						) : null}

						{store instanceof BetDetailsModalStore && (
							<Button
								type="button"
								switchIcon
								isMostPlayed
								className="btn--square btn--square--med btn--primary--inverted"
								iconClassName={
									"u-icon--tny u-icon--caret-right" +
									(store.isLast
										? " u-color--sent--muted"
										: " u-color--text--secondary")
								}
								iconOnly
								onClick={store.moveRight}
								disabled={store.isLast}
							/>
						)}
					</div>
				</div>
			</MyBetsBetContext.Provider>
		);
	}
);
